import { BasicProps } from "components/types/BasicProps";
import { FC } from "react";
import { FilterOption, FilterPossibleValue } from "./Filter";
import { Checkbox } from "components/Checkbox";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import classNames from "classnames";

type Props = BasicProps & { option: FilterOption };

const FilterCheckbox: FC<Props> = (props) => {
  const { option, className } = props;
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const values = searchParams.getAll(option.name);

  const handleInputClick = (filterValue: FilterPossibleValue) => {
    const params = new URLSearchParams(searchParams.toString());

    params[values.includes(filterValue.name) ? "delete" : "append"](
      option.name,
      filterValue.name
    );

    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  };

  return (
    <li className={classNames("flex flex-col gap-4", className)}>
      {option.label && (
        <div
          className="pb-2.5 border-b border-b-white"
        >
          <h4 className="text-base font-normal">{option.label}</h4>
        </div>
      )}
      <ul className="flex flex-col gap-4">
        {option.values.map((value, i) => {
          const isChecked = values.includes(value.name);

          return (
            <Checkbox
              className="text-xs"
              checked={isChecked}
              id={value.name}
              name={option.name}
              value={value.name}
              checkedBgColor={
                i === 0
                  ? "pink"
                  : i === 1
                    ? "orange"
                    : i === 2
                      ? "green"
                      : "primary"
              }
              onChange={() => handleInputClick(value)}
            >
              <Checkbox.Label htmlFor={value.name}>
                {value.label}
              </Checkbox.Label>
            </Checkbox>
          );
        })}
      </ul>
    </li>
  );
};

export default FilterCheckbox;
